window.DevisCart = (function () {
  var STORAGE_KEY = 'devisCart';

  function getAll() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveAll(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('devis-cart:updated', { detail: { items: items } }));
  }

  function has(id) {
    return getAll().some(function (i) { return i.id === id; });
  }

  function add(item) {
    var items = getAll();
    if (!items.some(function (i) { return i.id === item.id; })) {
      items.push(item);
      saveAll(items);
    }
    return items;
  }

  function remove(id) {
    var items = getAll().filter(function (i) { return i.id !== id; });
    saveAll(items);
    return items;
  }

  function clear() {
    saveAll([]);
  }

  function count() {
    return getAll().length;
  }

  return { getAll: getAll, add: add, remove: remove, clear: clear, count: count, has: has };
})();

document.addEventListener('DOMContentLoaded', function () {
  function updateButtonState(btn) {
    var raw = btn.getAttribute('data-devis-item');
    if (!raw) return;
    var item;
    try { item = JSON.parse(raw); } catch (e) { return; }
    var added = window.DevisCart.has(item.id);
    btn.textContent = added
      ? (btn.getAttribute('data-devis-label-added') || '✓ Dans mon devis (retirer)')
      : (btn.getAttribute('data-devis-label') || 'Ajouter au devis');
    btn.classList.toggle('is-added', added);
  }

  function refreshAll() {
    document.querySelectorAll('.devis-add-btn').forEach(updateButtonState);
    var count = window.DevisCart.count();
    document.querySelectorAll('[data-devis-feedback]').forEach(function (fb) {
      fb.hidden = count === 0;
      var countEl = fb.querySelector('[data-devis-count]');
      if (countEl) countEl.textContent = count;
    });
  }

  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('.devis-add-btn');
    if (!btn) return;
    e.preventDefault();
    var raw = btn.getAttribute('data-devis-item');
    var item;
    try { item = JSON.parse(raw); } catch (err) { return; }
    if (window.DevisCart.has(item.id)) {
      window.DevisCart.remove(item.id);
    } else {
      window.DevisCart.add(item);
    }
    refreshAll();
  });

  document.addEventListener('devis-cart:updated', refreshAll);

  refreshAll();
});
